import { useStartSingleReportTemplateSectionWorkflowMutation } from "@api/graphql/types-and-hooks";
import { notifyWarn } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface UseRegenerateSectionOptions {
  onSettled?: () => void;
}

// Single-section Regenerate, shared by the action menu and the recovery panel.
// The mutation reports a failure to start as `status: false` in a successful response
// rather than as an error, so it has to be surfaced here or Regenerate silently does
// nothing — which on a stalled section, with Remove withheld, leaves no way out.
// Mirrors the legacy SectionWidgetWrapper warning.
export const useRegenerateSection = ({ onSettled }: UseRegenerateSectionOptions = {}) => {
  const { reportQuery } = useReport();

  return useStartSingleReportTemplateSectionWorkflowMutation({
    onSuccess: async (data) => {
      const result = data.startSingleReportTemplateSectionWorkflow;
      if (result?.status === false) {
        notifyWarn(result.message || "Something went wrong generating this section");
      }
      await reportQuery.refetch();
    },
    onSettled,
  });
};
